import { render, staticRenderFns } from "./GTabLinks.vue?vue&type=template&id=53fcc257&"
import script from "./GTabLinks.vue?vue&type=script&lang=ts&"
export * from "./GTabLinks.vue?vue&type=script&lang=ts&"
import style0 from "./GTabLinks.vue?vue&type=style&index=0&lang=scss&scopoed=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports